



































































import { SvgImage, TwButton } from '@/app/components';
import { useLocations, useModelBrowser } from '@/app/composable';
import store from '@/app/store';
import { emailValidator, requiredValidator } from '@/app/validators';
import { useOrganisation } from '@/modules/organization/composable';
import { defineComponent, reactive, ref } from '@vue/composition-api';
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate';
import Auth from '../api/auth';

extend('required', requiredValidator);
extend('email', emailValidator);

export default defineComponent({
    name: 'Login',
    metaInfo: {
        title: 'Login',
    },
    components: { TwButton, ValidationObserver, ValidationProvider, SvgImage },
    setup(props, { root }) {
        const path = root.$route.params.path || '/overview'; // Check if user was redirected here, so we redirect him to the correct page
        const loginForm = ref<any>(null);
        const message = ref(null);
        const loading = ref(false);
        const credentials = reactive({
            email: '',
            password: '',
        });

        const login = async () => {
            message.value = null;
            if (await loginForm.value.validate()) {
                loading.value = true;
                Auth.login(credentials)
                    .then(async () => {
                        const { data } = await Auth.user();
                        store.commit.auth.SET_USER(data);
                        useModelBrowser().initialize();
                        useLocations().initialize();
                        if (data.organisationId) useOrganisation(data.organisationId).initialize();
                        store.dispatch.notificationEngine.fetchNotifications();
                        store.dispatch.executionVersions.loadVersions();
                        store.dispatch.executionErrors.loadExecutionErrors();
                        store.dispatch.dataModel.loadDomains();
                        if (process.env.VUE_APP_ETH_NODE)
                            store.dispatch.sharing.loadProviderAndNetwork(process.env.VUE_APP_ETH_NODE);
                        root.$router.push(path);
                        loading.value = false;
                    })
                    .catch((err) => {
                        message.value =
                            err.response.status === 403 ? 'The account is not activated' : err.response.data.message;

                        loading.value = false;
                    });
            }
        };

        return {
            credentials,
            loginForm,
            login,
            message,
            loading,
        };
    },
});
